import { useMutation } from '@api/hooks'
import { MarketBasket } from '@domain'
import MarketBasketsApi, { MarketBasketsKeys } from '@services/marketBaskets.api'
import { useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

export function useUpdateBlanketMarkup(marketBasketId: Id) {
	const queryClient = useQueryClient()
	const queryKey = MarketBasketsKeys.marketBasket(marketBasketId)

	return useMutation({
		mutationFn: MarketBasketsApi.updateBlanketMarkup,
		onMutate: async ({ markupType, markupAmount }) => {
			await queryClient.cancelQueries({ queryKey })

			const previousMarketBasket = queryClient.getQueryData<MarketBasket>(queryKey)

			queryClient.setQueryData<MarketBasket>(
				queryKey,
				(old) => old && { ...old, blanketMarkupType: markupType, blanketMarkupAmount: markupAmount }
			)

			return { previousMarketBasket }
		},
		onError: (error: AxiosError<{ message: string }>, _variables, context) => {
			if (context?.previousMarketBasket) {
				queryClient.setQueryData(queryKey, context.previousMarketBasket)
			}
			toast.error(error?.response?.data?.message, { duration: 20000 })
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: ['market-baskets'] })
			queryClient.invalidateQueries({ queryKey })
		},
	})
}

export function useRemoveBlanketMarkup(marketBasketId: Id) {
	const queryClient = useQueryClient()
	const queryKey = MarketBasketsKeys.marketBasket(marketBasketId)

	return useMutation({
		mutationFn: MarketBasketsApi.removeBlanketMarkup,
		onMutate: async () => {
			await queryClient.cancelQueries({ queryKey })

			const previousMarketBasket = queryClient.getQueryData<MarketBasket>(queryKey)

			queryClient.setQueryData<MarketBasket>(
				queryKey,
				(old) => old && { ...old, blanketMarkupType: null, blanketMarkupAmount: null }
			)

			return { previousMarketBasket }
		},
		onError: (error: AxiosError<{ message: string }>, _variables, context) => {
			if (context?.previousMarketBasket) {
				queryClient.setQueryData(queryKey, context.previousMarketBasket)
			}
			toast.error(error?.response?.data?.message, { duration: 20000 })
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: ['market-baskets'] })
			queryClient.invalidateQueries({ queryKey })
		},
	})
}
